var exports = {
  "k": "x804f0401--3287d5--container",
  "N": "x804f0401--3287d5--container-experimental",
};

module.exports = exports;
